var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPilotagereseau(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}.e{fill:#098bcc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 180,
    height: 180,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M99.49,30.02c-12.25-3.31-24.73-.66-34.34,6.19-7.45,5.29-13.18,13.11-15.74,22.6-.96,3.55-1.41,7.11-1.41,10.62v73.36c0,4.75,3.85,8.6,8.6,8.6s8.6-3.85,8.6-8.6v-40.04c3.84,2.74,8.2,4.84,13.01,6.14,3.55,.96,7.12,1.41,10.62,1.41,9.01,0,17.64-3,24.64-8.28,6.99-5.28,12.35-12.84,14.81-21.93,5.87-21.74-7.04-44.21-28.79-50.07Zm12.19,45.6c-3.4,12.58-16.4,20.06-29,16.67-10.53-2.84-17.48-12.41-17.48-22.84,0-2.03,.26-4.1,.82-6.15,2.84-10.54,12.41-17.49,22.84-17.49,2.03,0,4.1,.27,6.15,.82,12.59,3.4,20.07,16.41,16.68,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M99.28,90.71c-.24,.11-.47,.23-.71,.33,.23-.13,.47-.24,.71-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M123.38,151.35c-3.23,0-6.32-1.82-7.8-4.94l-14.24-30.25c2.9-.55,9.19-2.27,15.45-7.57l14.35,30.48c2.76,5.53-1.66,12.41-7.77,12.27Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotagereseau);
export default __webpack_public_path__ + "static/media/pilotagereseau.faaad7a2f8418cb50f2286c38c093dbe.svg";
export { ForwardRef as ReactComponent };